var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComingSoonDp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9935 0.835938C3.3135 0.835938 0.333496 3.8226 0.333496 7.5026C0.333496 11.1826 3.3135 14.1693 6.9935 14.1693C10.6802 14.1693 13.6668 11.1826 13.6668 7.5026C13.6668 3.8226 10.6802 0.835938 6.9935 0.835938ZM7.00016 12.8359C4.0535 12.8359 1.66683 10.4493 1.66683 7.5026C1.66683 4.55594 4.0535 2.16927 7.00016 2.16927C9.94683 2.16927 12.3335 4.55594 12.3335 7.5026C12.3335 10.4493 9.94683 12.8359 7.00016 12.8359ZM7.3335 4.16927H6.3335V8.16927L9.8335 10.2693L10.3335 9.44927L7.3335 7.66927V4.16927Z",
    fill: "#A9ADCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoonDp);
export default __webpack_public_path__ + "static/media/coming-soon-dp.4f280615f1b9173cf52a878caecf5097.svg";
export { ForwardRef as ReactComponent };